"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrewBlaster = exports.getAlienBlaster = exports.create = exports.createData = exports.EDiveWeaponState = void 0;
var diveSlashEffect_1 = require("@dive/effects/diveSlashEffect");
var diveEnums_1 = require("@dive/enums/diveEnums");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var EDiveWeaponState;
(function (EDiveWeaponState) {
    EDiveWeaponState[EDiveWeaponState["Reloading"] = 0] = "Reloading";
    EDiveWeaponState[EDiveWeaponState["Ready"] = 1] = "Ready";
    EDiveWeaponState[EDiveWeaponState["PreAttack1"] = 2] = "PreAttack1";
    EDiveWeaponState[EDiveWeaponState["PreAttack2"] = 3] = "PreAttack2";
    EDiveWeaponState[EDiveWeaponState["PostAttack"] = 4] = "PostAttack";
})(EDiveWeaponState = exports.EDiveWeaponState || (exports.EDiveWeaponState = {}));
var _default = {
    damage: 5,
    reloadTime: 5,
    preAttack1Time: 1,
    preAttack2Time: 1,
    postAttackTime: 1,
    maxDistance: 1.5,
    speed: 300,
    color: voyageColors_sidecar_1.voyageColors.red,
    type: diveEnums_1.EMessageBulletTeamType.Crew,
    bulletType: diveEnums_1.EDiveBulletSubtype.MeleeSlash,
    bulletTracking: diveEnums_1.EDiveBulletTracking.Tile,
    hitEffect: diveSlashEffect_1.EDiveSlashEffect.Slash,
    damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Slash,
    bulletFrame: 'none',
    physicalBlockChance: 0,
};
function createData(data) {
    var d = Object.assign({}, _default, data);
    return d;
}
exports.createData = createData;
function create(data) {
    return {
        data: data,
        timer: 0,
        state: EDiveWeaponState.Ready,
    };
}
exports.create = create;
function getAlienBlaster() {
    return {
        damage: 15,
        reloadTime: 3,
        preAttack1Time: 1,
        preAttack2Time: 1,
        postAttackTime: 1,
        maxDistance: 500,
        speed: 200,
        color: voyageColors_sidecar_1.voyageColors.green,
        type: diveEnums_1.EMessageBulletTeamType.Alien,
        bulletType: diveEnums_1.EDiveBulletSubtype.MeleeSlash,
        bulletTracking: diveEnums_1.EDiveBulletTracking.Tile,
        hitEffect: diveSlashEffect_1.EDiveSlashEffect.FireExplosion,
        damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.SmallBullet,
        bulletFrame: 'none',
        physicalBlockChance: 0,
    };
}
exports.getAlienBlaster = getAlienBlaster;
function getCrewBlaster() {
    return {
        damage: 25,
        reloadTime: 2,
        preAttack1Time: 1,
        preAttack2Time: 1,
        postAttackTime: 1,
        maxDistance: 300,
        speed: 300,
        color: voyageColors_sidecar_1.voyageColors.red,
        type: diveEnums_1.EMessageBulletTeamType.Crew,
        bulletType: diveEnums_1.EDiveBulletSubtype.MeleeSlash,
        bulletTracking: diveEnums_1.EDiveBulletTracking.Tile,
        hitEffect: diveSlashEffect_1.EDiveSlashEffect.FireExplosion,
        damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.SmallBullet,
        bulletFrame: 'none',
        physicalBlockChance: 0,
    };
}
exports.getCrewBlaster = getCrewBlaster;
// export function getCrewFists(): IDiveCrewWeaponData {
//   return {
//     damage: 5,
//     reloadTime: 5,
//     maxDistance: 1.5,
//     speed: 300,
//     color: voyageColors.red,
//     type: EMessageBulletTeamType.Crew,
//     bulletType: EDiveBulletSubtype.MeleeSlash,
//     hitEffect: EDiveSlashEffect.Slash,
//     damageType: EVoyageCrewDamageType.Slash,
//     bulletSprites: [],
//   }
// }
// export function getCrewSword(): IDiveCrewWeaponData {
//   return {
//     damage: 25,
//     reloadTime: 5,
//     maxDistance: 1.5,
//     speed: 300,
//     color: voyageColors.red,
//     type: EMessageBulletTeamType.Crew,
//     bulletType: EDiveBulletSubtype.MeleeSlash,
//     hitEffect: EDiveSlashEffect.Slash,
//     damageType: EVoyageCrewDamageType.Slash,
//     bulletSprites: [],
//   }
// }
// export function getCrewFireball(): IDiveCrewWeaponData {
//   return {
//     damage: 25,
//     reloadTime: 10,
//     maxDistance: 6,
//     speed: 300,
//     color: voyageColors.red,
//     type: EMessageBulletTeamType.Crew,
//     bulletType: EDiveBulletSubtype.Fireball,
//     hitEffect: EDiveSlashEffect.FireExplosion,
//     bulletSprites: [sprites.diveEffects60C48[0]],
//     damageType: EVoyageCrewDamageType.Magic,
//   }
// }
// export function getCrewBow(): IDiveCrewWeaponData {
//   return {
//     damage: 25,
//     reloadTime: 7,
//     maxDistance: 5,
//     speed: 300,
//     color: voyageColors.red,
//     type: EMessageBulletTeamType.Crew,
//     bulletType: EDiveBulletSubtype.Arrow,
//     hitEffect: EDiveSlashEffect.ArrowHit,
//     damageType: EVoyageCrewDamageType.Pierce,
//     bulletSprites: [sprites.diveEffects71C57[0]],
//   }
// }
